import one360 from './one360';
import type { RegisterVaillantSerialNumberResult } from '../../interfaces/vaillant';

/**
 * `idempotencyKey`: von der One360-API bereitgestellter Dedup-Mechanismus (#1202, Antwort auf
 * das Backend-Ticket zu #1199) — pro Registrierungsversuch einmal erzeugt und bei jedem Retry
 * (auch aus der Offline-Queue, siehe queueService.processVaillantSerialRegister) unverändert
 * mitgeschickt. Ein wiederholter Aufruf mit demselben Schlüssel für dieselbe Seriennummer
 * kontaktiert Vaillant NICHT erneut, sondern liefert das ursprüngliche Ergebnis zurück -
 * schließt die Restlücke, die die manuelle Bestätigung in PhaseScreen bisher nur clientseitig
 * absichern konnte. Optional gehalten: ohne Key bleibt der Aufruf unverändert (Rückwärts-
 * kompatibilität laut Backend-Contract).
 */
export async function registerVaillantSerialNumber(
  serialNumber: string,
  email?: string,
  signal?: AbortSignal,
  idempotencyKey?: string,
): Promise<RegisterVaillantSerialNumberResult> {
  return one360.post<RegisterVaillantSerialNumberResult>(
    '/api/v1/vaillant/register-serial-number',
    { serialNumber, email },
    {
      signal,
      headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
    },
  );
}
